module.exports = {
  clientName: 'SEGI',
  // baseAPI: '"https://api.segi.docutag.io"',
  // verifyURL: '"https://verify.segi.edu.my"',
  CampusName: 'Student Certificates',
  // baseAPI: '"https://api.staging.docutag.io"',
  baseAPI: '"https://uat.api.segi.docutag.io"',
  verifyURL: '"https://uat.verify.segi.docutag.io"'
}



// WEBPACK FOOTER //
// ./src/clientConfiguration.js